module.exports = __webpack_public_path__ + "static/media/marcas (6).659cc3f3.jpg";